import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_TIME_CARD_REPORT } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const timeCardReport = {
  namespaced: true,
  state: buildInitialState({
    timeCardReport: {
      assignment: {},
      payTimePeriods: [],
      invoicingTimePeriods: [],
      timeCardEntries: [],
      typeSummaries: []
    }
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearTimeCardReport: (state) => {
      state.timeCardReport = {
        assignment: {},
        payTimePeriods: [],
        invoicingTimePeriods: [],
        timeCardEntries: [],
        typeSummaries: []
      }
    },
    setTimeCardReport: (state, timeCardReport) => {
      if (timeCardReport) {
        state.timeCardReport = Object.assign({}, timeCardReport)
      } else {
        state.timeCardReport = {
          assignment: {},
          payTimePeriods: [],
          invoicingTimePeriods: [],
          timeCardEntries: []
        }
      }
    }
  },
  actions: {
    getTimeCardReport: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting time card, please wait...' })

      return api.doGet({ path: PATH_TIME_CARD_REPORT, parameters: filters })
        .then(json => json.data)
        .then(timeCardReport => {
          commit('updateStatus', { status: COMPLETE })
          commit('setTimeCardReport', timeCardReport)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get time card.')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getTimeCardReportWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getTimeCardReport', { ...rootGetters['timeCardReportFilters/getSearchObject'] })
    },
    clearTimeCardReport ({ commit }) {
      commit('clearTimeCardReport')
    }
  }
}

export default timeCardReport
